import {sollIstRequestRefreshAction} from 'module/SollIst/action/SollIstAction'
import {filter, mergeMap} from 'rxjs/operators'
import {Epic} from 'redux-observable'
import {bsRefreshCollectionAction} from 'module/BSCollection/action/BSCollectionAction'
import {bufferThrottleTime} from 'util/rxjsOperators/bufferThrottleTime'
import {SisName} from 'util/SisName'
import {parseSisDate} from 'util/SisDateTime'

export const SollIstEpic: Epic = (action$, state$) => action$.pipe(
	filter(sollIstRequestRefreshAction.match),
	bufferThrottleTime(5000),
	mergeMap((actions) => {
		const persNrs = new Set<number>()
		const dates = new Set<number>()
		actions.forEach(action => {
			persNrs.add(action.payload.persNr)
			dates.add(action.payload.date)
		})
		const from = +parseSisDate(Math.min(...dates))
		const to = +parseSisDate(Math.max(...dates)).endOf('day')
		const overrideOwners = [...persNrs].sort()
		return [
			bsRefreshCollectionAction({
				sisName: SisName.Ist,
				overrideOwners,
				from,
				to,
				force: true,
			}),
			bsRefreshCollectionAction({
				sisName: SisName.StTagZu,
				overrideOwners,
				from,
				to,
				force: true,
			}),
		]
	}),
)